import { SelectBox } from "@/ui-kit";
import { UseComboboxSelectedItemChange } from "downshift";
import Fuse from "fuse.js";
import { useMemo, useState, useEffect, ReactNode } from "react";

export function SelectorSearch<T>({
  items,
  defaultSelectedItem,
  placeholder,
  onSelectedItemChange,
  icon,
  itemToString,
}: {
  items: T[];
  defaultSelectedItem: T | null;
  placeholder: string;
  onSelectedItemChange: (
    changes: UseComboboxSelectedItemChange<T | null>
  ) => void;
  icon?: ReactNode;
  itemToString?: (item: T | null) => string;
}) {
  const fuse = useMemo(
    () =>
      new Fuse(items, {
        keys: ["name"],
      }),
    [items]
  );
  const [filteredItems, setFilteredItems] = useState(items);

  useEffect(() => {
    setFilteredItems(items);
  }, [items]);

  return (
    <SelectBox<T>
      items={filteredItems}
      showListToggleButton
      icon={icon}
      onInputValueChange={({ inputValue }) => {
        if (inputValue === "") {
          setFilteredItems(items);
        } else {
          setFilteredItems(
            fuse.search(inputValue).map((result) => result.item)
          );
        }
      }}
      onSelectedItemChange={onSelectedItemChange}
      placeholder={placeholder}
      itemToString={itemToString}
      defaultSelectedItem={defaultSelectedItem}
    />
  );
}
